<style lang="scss" scoped>
@import 'common/sass/reuse.SCSS';
</style>

<template>
  <div class="maintenance-box">
    <div :element-loading-text="loadText" class="panel" v-loading="loading">
      <custom-table
        :downloadLoading="downloadLoading"
        :downLoadTran="downLoadTran"
        :jsonExcelAjax="jsonExcelAjax"
        :name="name"
        :page="page"
        :selPage="selPage"
        :tableHead="tableHead"
        :tbodyData="tbodyData"
        @tableChange="ajaxHandle"
      >
        <div class="search-box" slot="search">
          <div class="select-type" style="margin-top: 2px;">
            <el-switch :active-text="reuse.moreSelect" inactive-text v-model="more"></el-switch>
          </div>
          <div class="select-type">
            <span v-text="language.timeText"></span>
            <el-date-picker
              :end-placeholder="reuse.endTime"
              :picker-options="pickerOptions"
              :start-placeholder="reuse.startTime"
              style="width:220px"
              type="daterange"
              v-model="formData.dateRange"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </div>
          <div class="select-type">
            <span v-text="reuse.loginText"></span>
            <el-input clearable style="width:220px;" v-model="formData.login"></el-input>
          </div>
          <div class="select-type">
            <span v-text="reuse.groupText"></span>
            <el-input clearable style="width:220px;" v-model="formData.group"></el-input>
          </div>
          <div class="select-type">
            <el-button @click="filterHandle" type="primary" v-text="reuse.searchText"></el-button>
          </div>
        </div>
        <div class="extraSearch" slot="more-filters" v-show="more">
          <div class="searchDiv">
            <span v-text="reuse.ibNumText"></span>
            <el-input clearable style="width:220px;" v-model="formData.ibNum"></el-input>
          </div>
          <div class="searchDiv">
            <span v-text="reuse.officeText"></span>
            <el-input clearable style="width:220px;" v-model="formData.office"></el-input>
          </div>
          <div class="searchDiv">
            <span v-text="reuse.regionText"></span>
            <el-input clearable style="width: 210px;" v-model="formData.region"></el-input>
          </div>
          <div class="searchDiv">
            <span v-text="reuse.nameFilterText"></span>
            <el-input clearable style="width:220px;" v-model="formData.nameFilter"></el-input>
          </div>
          <div class="searchDiv">
            <span v-text="reuse.loginFilterText"></span>
            <el-input clearable style="width:220px;" v-model="formData.loginFilter"></el-input>
          </div>
        </div>
      </custom-table>
    </div>
  </div>
</template>

<script>
import customTable from 'components/reuseTable'
import { URL_EQUITY_MULTI_REPORT } from 'api/api'
import { days } from 'api/env'
import { onPick } from 'common/js/util'

const data = () => {
  return {
    tbodyData: [],
    loading: false,
    downloadLoading: true,
    loadText: '',
    more: false,
    formData: {
      dateRange: [],
      login: null,
      group: null,
      ibNum: null,
      office: null,
      region: null,
      nameFilter: null,
      loginFilter: null
    },
    pickerOptions: {
      disabledDate(time) {
        let now = new Date()
        now.setTime(now.getTime() - 24 * 36e5)
        return time.getTime() > now
      },
      onPick: onPick
    },
    page: {
      active: 1,
      pageLeng: 0,
      offset: 0
    },
    selPage: {
      list: ['5', '10', '25', '50'],
      active: 1,
      limit: 10
    }
  }
}

const mixins = [require('common/mixin/base').base({ language: 'mt4EquityMultiReport' }), require('common/mixin/base').base({ reuse: 'reuse' })]

const computed = {
  name() {
    const date = this.formData.dateRange
    return `${this.language.downloadName}_${date ? date.map(val => val.replace(/-/g, '')).join('-') : ''}`
  },
  tableHead() {
    const redColorColumns = ['CLOSED_PL','DEPOSIT','BALANCE','FLOATING_PL','CREDIT','EQUITY','USED_MARGIN','MARGIN_FREE']
    this.language.tableHead.forEach(head => {
        if(redColorColumns.includes(head.key)) head.redColor = true;
    })
    return this.language.tableHead
  },
  downLoadTran() {
    return {
      loadText: this.language.loadText
    }
  },
  jsonExcelAjax() {
    return {
      url: URL_EQUITY_MULTI_REPORT,
      ajaxType: 'post',
      getKey: ['data', 'data', 'data'],
      ajaxPar: {
        ...this.formData,
        pageSize: -1,
        pageNum: 0
      }
    }
  }
}

const created = function() {
  const defaultEnd = this.$moment()
    .subtract(1, 'd')
    .format('YYYY-MM-DD')
  const defaultStart = this.$moment()
    .subtract(3, 'd')
    .format('YYYY-MM-DD')
  this.formData.dateRange.push(defaultStart)
  this.formData.dateRange.push(defaultEnd)
  this.ajaxHandle()
}

const methods = {
  filterHandle() {
    this.page.active = 1
    this.ajaxHandle()
  },
  ajaxHandle() {
    this.loading = true
    this.formData.pageNum = this.page.active
    this.formData.pageSize = this.selPage.limit
    this.$http
      .post(URL_EQUITY_MULTI_REPORT, this.formData)
      .then(res => {
        if (Object.prototype.toString.call(res.data.data.data) === '[object Array]') {
          this.page.pageLeng = res.data.data.count
          this.tbodyData = res.data.data.data
        } else {
          this.tbodyData = []
          this.page.pageLeng = 0
        }
        if (res.data.msg !== 'OK') this.$message.error(this.reuse.invalidParam)
        this.loading = false
      })
      .catch(e => {
        alert(this.reuse.serverError)
      })
  },
  blurHandle(obj) {
    this.pickerOption.disabledDate = function(time) {
      let now = new Date()
      now.setTime(now.getTime() - 24 * 36e5)
      return time.getTime() > now
    }
  }
}

const components = {
  customTable
}

export default {
  data,
  mixins,
  computed,
  created,
  methods,
  components
}
</script>


// WEBPACK FOOTER //
// src/views/manager-report/mt4-equity-multi-report.vue